import React from 'react';
import { Button } from 'junto-ui';
import { PageTitle, ButtonFlat } from 'components-core';
import { useStore } from '@store';
import { logEvent } from '@ncl/modules/shared/utils';
import AccountServices from '@ncl/modules/account/services/AccountServices';

import ErrorIllustration from '@ncl/assets/images/ErrorIllustration';
import BoxWithMargin from '../../BoxWithMargin';

export default () => {
  const sharedStore = useStore('sharedStore');

  return (
    <>
      <ErrorIllustration />
      <BoxWithMargin
        desktop={{ bottom: '40px', top: '40px' }}
        responsive={{ bottom: '24px', top: '24px' }}
      >
        <PageTitle maxWidth="448px">
          Ops! Tivemos um problema técnico. Tente novamente ou fale com a gente no Chat.
        </PageTitle>
      </BoxWithMargin>
      <BoxWithMargin
        desktop={{ bottom: '32px' }}
        responsive={{ bottom: '24px' }}
        desktopWidth="100%"
        responsiveWidth="100%"
      >
        <Button
          variant="primary"
          size="big"
          onClick={() => {
            logEvent('click-retry');
            AccountServices.validatePendingTerms();
            sharedStore.clearErrors();
          }}
        >
          Tentar novamente
        </Button>
      </BoxWithMargin>
      <ButtonFlat
        onClick={() => {
          if (!window.zE) return;
          window.zE('webWidget', 'open');
        }}
      >
        Fale com a gente no Chat
      </ButtonFlat>
    </>
  );
};
